/**
 * 运营策略详情页常量定义
 */

// SKU状态选项
export const STATUS_OPTIONS = [
    { value: 'developing', label: '开发中' },
    { value: 'sample', label: '样品测试' },
    { value: 'planning', label: '计划中' },
    { value: 'active', label: '在售' },
    { value: 'inactive', label: '停售' },
    { value: 'clearance', label: '清仓' },
    { value: 'discontinued', label: '已停售' },
] as const;

export type StatusValue = typeof STATUS_OPTIONS[number]['value'];
